import { render, staticRenderFns } from "./dotDeploy.vue?vue&type=template&id=53a5d722&scoped=true"
import script from "./dotDeploy.vue?vue&type=script&lang=js"
export * from "./dotDeploy.vue?vue&type=script&lang=js"
import style0 from "./dotDeploy.vue?vue&type=style&index=0&id=53a5d722&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a5d722",
  null
  
)

export default component.exports